<template>
  <div class="tab-content">
    <div class="list">
      <div
        class="item"
        v-for="(item, index) in tabList"
        :key="index"
        @click="bindSelect(item)"
      >
        <span>{{ item.title }}</span>
        <span class="iconfont icon-you"></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      tabList: [
        {
          title: '首次餐卡',
          type: 1
        }
      ]
    }
  },
  created() {},
  methods: {
    bindSelect(item) {
      this.$router.push({
        path: '/not-camp-review-tool/list',
        query: {
          meal_attr: item.type
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.tab-content {
  padding: 16px;
  .list {
    .item {
      background-color: rgb(248, 248, 248);
      padding: 14px 16px;
      border-radius: 6px;
      font-size: 14px;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }
}
</style>
